// src/config/firebaseConfig.js
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase client-side configuration
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "dashop-ed218.firebaseapp.com",
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL || "https://dashop-ed218-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "dashop-ed218",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "dashop-ed218.appspot.com",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "911253301722",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:911253301722:web:6e2486f7b5b01b3c2038e3"
};

// Initialize Firebase client-side
let app;
let auth;
let provider;
let db;

// Check if we're in the browser environment
if (typeof window !== 'undefined') {
  try {
    // Initialize Firebase client only if no apps exist
    if (!getApps().length) {
      app = initializeApp(firebaseConfig);
    } else {
      app = getApps()[0];
    }

    auth = getAuth(app);
    provider = new GoogleAuthProvider();
    db = getFirestore(app);
  } catch (error) {
    // Only log errors; remove if you want to silence everything
    console.error("Firebase initialization error:", error);

    // Create placeholders so code that references these objects won’t break
    auth = {
      currentUser: null,
      onAuthStateChanged: (callback) => {
        callback(null);
        return () => {}; // dummy unsubscribe function
      }
    };
    provider = {};
    db = {};
  }
}

// Wrapper for getIdToken that handles errors gracefully
export const getIdToken = async () => {
  if (!auth?.currentUser) return null;

  try {
    return await auth.currentUser.getIdToken(true);
  } catch (error) {
    console.error('Error getting ID token:', error);
    return null;
  }
};

// Wrapper for signInWithPopup that handles errors better
export const signInWithGooglePopup = async () => {
  try {
    if (!auth || !provider) {
      throw new Error("Firebase auth not initialized");
    }
    return await signInWithPopup(auth, provider);
  } catch (error) {
    console.error("Google sign-in error:", error);
    throw error;
  }
};

// Wrapper for signOut
export const signOutUser = async () => {
  try {
    if (!auth) {
      throw new Error("Firebase auth not initialized");
    }
    return await signOut(auth);
  } catch (error) {
    console.error("Sign out error:", error);
    throw error;
  }
};

// Export client-side functions and objects
export {
  app,
  auth,
  provider,
  db,
  signInWithPopup,
  signOut
};
